// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "switch__element-1xxbo";
var _3 = "switch__element_active-eX1nJ";
var _4 = "switch__element_error-2RSjS";
export { _1 as "__esModule", _2 as "switch__element", _3 as "switch__element_active", _4 as "switch__element_error" }
export default { "__esModule": _1, "switch__element": _2, "switch__element_active": _3, "switch__element_error": _4 }
